import { BrowserRouter } from 'react-router-dom';
import { AppRoutes } from './router';
import SEOSchema from './components/SEOSchema';

function App() {
  return (
    <BrowserRouter basename={__BASE_PATH__}>
      <SEOSchema />
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
